export const TYPE_BADGES = {
  devis: "bg-cyan-400/15 text-cyan-300 border-cyan-400/40",
  croquis: "bg-pink-500/15 text-pink-300 border-pink-500/40",
  accompagnement: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  covoiturage: "bg-blue-500/15 text-blue-300 border-blue-500/40",
};
export const TYPE_LABELS = { devis: "Devis", croquis: "Croquis", accompagnement: "Accompagnement", covoiturage: "Trajet" };
export const PAYMENT_LABELS = { paid: "Payé", pending: "En attente", processing: "En cours", unpaid: "En attente", expired: "Expiré", failed: "Échoué", refunded: "Remboursé", partially_refunded: "Remboursement partiel" };

export const formatDate = (iso) => {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "Date inconnue";
  return date.toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
};

export const contactHref = (contact) => {
  if (/^https?:\/\//i.test(contact)) return contact;
  if (contact.includes("@")) return `mailto:${contact}`;
  return `tel:${contact.replace(/\s/g, "")}`;
};

export const paymentModeLabel = (livemode) => {
  if (livemode === true) return "Réel";
  if (livemode === false) return "Test";
  return "Mode non renseigné";
};